export enum AuditStatus {
  PENDING = 'PENDING',
  AGENT_CLEARED = 'AGENT_CLEARED',
  AGENT_VIOLATION = 'AGENT_VIOLATION',
  TL_CONFIRMED_CLEARED = 'TL_CONFIRMED_CLEARED',
  TL_CONFIRMED_VIOLATION = 'TL_CONFIRMED_VIOLATION',
  TL_OVERRULED_TO_CLEARED = 'TL_OVERRULED_TO_CLEARED',
  TL_OVERRULED_TO_VIOLATION = 'TL_OVERRULED_TO_VIOLATION',
  TL_DIRECT_CLEARED = 'TL_DIRECT_CLEARED',
  TL_DIRECT_VIOLATION = 'TL_DIRECT_VIOLATION'
}

export enum AuditSubStatus {
  CONFIRMED = 'Confirmed',
  UPDATED = 'Updated',
  REVIEWED = 'Reviewed'
}
